import Progress from '@components/Progress'
import RoleBasedView from '@components/RoleBasedView'
import { ProgramContentProp } from '@layouts/LearningPath/ProgramContent/index'
import { Container, ProgressLabel } from '@layouts/LearningPath/ProgramContent/style'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Col } from 'react-styled-flexboxgrid'

const NonFlexProgress: React.FC<ProgramContentProp> = ({ Path }) => (
  <Container>
    <Col xs={9} md={2}>
      <ProgressLabel>
        <FormattedMessage id="Learning path" />
      </ProgressLabel>
      <Progress color="brandSecondary" percent={Path?.Progress} />
    </Col>
    <RoleBasedView configId="c::learningPath::progressbar::onlinePractice">
      <Col xs={9} md={2}>
        <ProgressLabel>
          <FormattedMessage id="Online practice" />
        </ProgressLabel>
        <Progress percent={100} />
      </Col>
    </RoleBasedView>
  </Container>
)

export default NonFlexProgress
